import { useSetRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { getNotificationTypes } from '../../services/notificationService';
import { notificationTypesState } from '../../storage/notifications';

function NotificationTypesProvider() {
  const setNotificationTypes = useSetRecoilState(notificationTypesState);

  useEffectOnce(() => {
    const load = async () => {
      const { notificationTypes, error } = await getNotificationTypes();
      if (!error && notificationTypes) {
        setNotificationTypes(
          notificationTypes.map((notificationType) => ({
            ...notificationType,
            internalId: `${notificationType.origin}-${notificationType.notificationId}`,
          })),
        );
      } else {
        setNotificationTypes(undefined);
      }
    };
    void load();
  });

  return null;
}

export default NotificationTypesProvider;
